/**
 * Recursively removes undefined values from an object or array.
 */
const removeUndefined = (obj: any[] | Record<string, any> | null | undefined): any => {
    if (Array.isArray(obj)) {
        return obj.map(removeUndefined);
    } else if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(
            Object.entries(obj)
                .filter(([, value]) => value !== undefined)
                .map(([key, value]) => [key, removeUndefined(value)]),
        );
    }
    return obj;
};

export { removeUndefined };
